import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope5mg03ltqqkp0 as coroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { DefaultClientWebSocketSession1n8ok3lng45wy as DefaultClientWebSocketSession } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/ClientSessions.mjs';
import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  Urlowwyg1lanrqp as Url,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import {
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstancek1529r0btmjl as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Close3tx65evcwi73t as Close,
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
} from '../../../../../ktor-ktor-websockets/io/ktor/websocket/Frame.web.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { readText30p9xkeoodw49 as readText } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/FrameCommon.mjs';
import { Plugin_getInstance3c2cbcxt5w9x2 as Plugin_getInstance } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/WebSockets.mjs';
import { headers24pki7ce1busg as headers } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/HttpRequest.mjs';
import { url1qder21xodqzl as url } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/buildersWithUrl.mjs';
import { webSocket1o6hkyb7h15pm as webSocket } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/builders.mjs';
import { CloseReason10cphaqpp3ct7 as CloseReason } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/CloseReason.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { HttpClient3584jcajl7sef as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KtorWebSocketEngine$open$slambda$slambda$slambda$slambdaClass;
function KtorWebSocketEngine$open$slambda$slambda$slambda$slambda() {
  if (KtorWebSocketEngine$open$slambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_webSocket) {
        this.c6f_1 = this$0;
        this.d6f_1 = $this_webSocket;
      }
      *r1f($this$launch, $completion) {
        yield* sendFrames(this.c6f_1, this.d6f_1, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    KtorWebSocketEngine$open$slambda$slambda$slambda$slambdaClass = $;
  }
  return KtorWebSocketEngine$open$slambda$slambda$slambda$slambdaClass;
}
function KtorWebSocketEngine$open$slambda$slambda$slambda$slambda_0(this$0, $this_webSocket) {
  var i = new (KtorWebSocketEngine$open$slambda$slambda$slambda$slambda())(this$0, $this_webSocket);
  var l = ($this$launch, $completion) => i.r1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var KtorWebSocketEngine$open$slambda$slambda$slambdaClass;
function KtorWebSocketEngine$open$slambda$slambda$slambda() {
  if (KtorWebSocketEngine$open$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_webSocket) {
        this.e6f_1 = this$0;
        this.f6f_1 = $this_webSocket;
      }
      *r1f($this$coroutineScope, $completion) {
        launch($this$coroutineScope, VOID, VOID, KtorWebSocketEngine$open$slambda$slambda$slambda$slambda_0(this.e6f_1, this.f6f_1));
        try {
          yield* receiveFrames(this.e6f_1, this.f6f_1.f5b(), $completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            var closeReason = yield* closeReasonOrNull(this.e6f_1, this.f6f_1, $completion);
            var tmp;
            if (!(closeReason == null)) {
              tmp = ApolloWebSocketClosedException().j4e(closeReason.w5a_1, closeReason.x5a_1, e);
            } else {
              tmp = ApolloNetworkException().t47('Web socket communication error', e);
            }
            var apolloException = tmp;
            this.e6f_1.x6e_1.d1b(apolloException);
            throw e;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    KtorWebSocketEngine$open$slambda$slambda$slambdaClass = $;
  }
  return KtorWebSocketEngine$open$slambda$slambda$slambdaClass;
}
function KtorWebSocketEngine$open$slambda$slambda$slambda_0(this$0, $this_webSocket) {
  var i = new (KtorWebSocketEngine$open$slambda$slambda$slambda())(this$0, $this_webSocket);
  var l = ($this$coroutineScope, $completion) => i.r1f($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var KtorWebSocketEngine$open$slambda$slambdaClass;
function KtorWebSocketEngine$open$slambda$slambda() {
  if (KtorWebSocketEngine$open$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.g6f_1 = this$0;
      }
      *h6f($this$webSocket, $completion) {
        yield* coroutineScope(KtorWebSocketEngine$open$slambda$slambda$slambda_0(this.g6f_1, $this$webSocket), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.h6f(p1 instanceof DefaultClientWebSocketSession() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    KtorWebSocketEngine$open$slambda$slambdaClass = $;
  }
  return KtorWebSocketEngine$open$slambda$slambdaClass;
}
function KtorWebSocketEngine$open$slambda$slambda_0(this$0) {
  var i = new (KtorWebSocketEngine$open$slambda$slambda())(this$0);
  var l = ($this$webSocket, $completion) => i.h6f($this$webSocket, $completion);
  l.$arity = 1;
  return l;
}
function *open($this, url, headers, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = URLBuilder(url);
  var tmp0_subject = url.q55_1;
  var tmp;
  if (tmp0_subject.equals(Companion_getInstance().c56_1)) {
    tmp = Companion_getInstance().e56_1;
  } else if (tmp0_subject.equals(Companion_getInstance().b56_1)) {
    tmp = Companion_getInstance().d56_1;
  } else if (tmp0_subject.equals(Companion_getInstance().d56_1) || tmp0_subject.equals(Companion_getInstance().e56_1)) {
    tmp = url.q55_1;
  } else {
    throw UnsupportedOperationException().a1('SOCKS is not a supported protocol');
  }
  this_0.a56(tmp);
  var newUrl = this_0.p37();
  launch($this.w6e_1, VOID, VOID, KtorWebSocketEngine$open$slambda_0($this, newUrl, headers));
  return new (KtorWebSocketEngine$open$5())($this);
}
function *closeReasonOrNull($this, $receiver, $completion) {
  var tmp;
  try {
    tmp = yield* $receiver.b5b().my($completion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var t = $p;
      if (t instanceof CancellationException()) {
        throw t;
      }
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function *sendFrames($this, session, $completion) {
  while (true) {
    var frame = yield* $this.y6e_1.w1a($completion);
    yield* session.h5b(frame, $completion);
    if (frame instanceof Close()) {
      $this.x6e_1.f1b();
    }
  }
  return Unit_instance;
}
function *receiveFrames($this, incoming, $completion) {
  while (true) {
    var frame = yield* incoming.w1a($completion);
    if (frame instanceof Text()) {
      $this.x6e_1.t1a(readText(frame));
    } else {
      if (frame instanceof Binary()) {
        $this.x6e_1.t1a(decodeToString(frame.j5c_1));
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unknown frame type';
        throw IllegalStateException().o(toString(message));
      }
    }
  }
  return Unit_instance;
}
function KtorWebSocketEngine$_init_$lambda_2axi3y($this$HttpClient) {
  $this$HttpClient.n5i(Plugin_getInstance());
  return Unit_instance;
}
var KtorWebSocketEngine$open$slambdaClass;
function KtorWebSocketEngine$open$slambda() {
  if (KtorWebSocketEngine$open$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $newUrl, $headers) {
        this.i6f_1 = this$0;
        this.j6f_1 = $newUrl;
        this.k6f_1 = $headers;
      }
      *r1f($this$launch, $completion) {
        try {
          var tmp = ($this$webSocket) => {
            headers($this$webSocket, ($this$headers) => {
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s = this.k6f_1.p1();
              while (_iterator__ex2g4s.q1()) {
                var element = _iterator__ex2g4s.r1();
                $this$headers.o4p(element.i49_1, element.j49_1);
              }
              return Unit_instance;
            });
            url($this$webSocket, this.j6f_1);
            return Unit_instance;
          };
          yield* webSocket(this.i6f_1.v6e_1, tmp, KtorWebSocketEngine$open$slambda$slambda_0(this.i6f_1), $completion);
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            this.i6f_1.x6e_1.d1b(ApolloNetworkException().t47('Web socket communication error', e));
          } else {
            throw $p;
          }
        }
        finally {
          this.i6f_1.x6e_1.d1b(ApolloNetworkException().t47('Web socket communication error', null));
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    KtorWebSocketEngine$open$slambdaClass = $;
  }
  return KtorWebSocketEngine$open$slambdaClass;
}
function KtorWebSocketEngine$open$slambda_0(this$0, $newUrl, $headers) {
  var i = new (KtorWebSocketEngine$open$slambda())(this$0, $newUrl, $headers);
  var l = ($this$launch, $completion) => i.r1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var KtorWebSocketEngine$open$5Class;
function KtorWebSocketEngine$open$5() {
  if (KtorWebSocketEngine$open$5Class === VOID) {
    class $ {
      constructor(this$0) {
        this.l6f_1 = this$0;
      }
      *i6e($completion) {
        return yield* this.l6f_1.x6e_1.w1a($completion);
      }
      g6e(data) {
        this.l6f_1.y6e_1.t1a(Binary().p5f(true, data.r3x()));
      }
      h6e(string) {
        this.l6f_1.y6e_1.t1a(Text().z5f(string));
      }
      l6() {
        this.l6f_1.y6e_1.t1a(Close().f5c(CloseReason().y5a(1000, '')));
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [0]);
    KtorWebSocketEngine$open$5Class = $;
  }
  return KtorWebSocketEngine$open$5Class;
}
var KtorWebSocketEngineClass;
function KtorWebSocketEngine() {
  if (KtorWebSocketEngineClass === VOID) {
    class $ {
      static z6e(client) {
        var $this = createThis(this);
        $this.v6e_1 = client;
        $this.w6e_1 = CoroutineScope_0(Dispatchers_getInstance().x12_1.gm(SupervisorJob()));
        $this.x6e_1 = Channel(2147483647);
        $this.y6e_1 = Channel(2147483647);
        return $this;
      }
      static m6f() {
        return this.z6e(HttpClient(KtorWebSocketEngine$_init_$lambda_2axi3y));
      }
      *d6d(url, headers, $completion) {
        return yield* /*#__NOINLINE__*/open(this, Url(url), headers, $completion);
      }
    }
    initMetadataForClass($, 'KtorWebSocketEngine', $.m6f, VOID, VOID, [2, 1]);
    KtorWebSocketEngineClass = $;
  }
  return KtorWebSocketEngineClass;
}
//region block: exports
export {
  KtorWebSocketEngine as KtorWebSocketEngine2cbfnq8i807su,
};
//endregion

//# sourceMappingURL=KtorWebSocketEngine.mjs.map
